import { Button, message, Popconfirm } from 'antd';
import { publishClass, rejectClass } from '../ApiServices/classAdminApi';

export const getClassesTableColumns = (navigate, fetchClasses, currentPage) => [
  {
    title: "Class Title",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Class Level",
    dataIndex: "education_class",
    key: "education_class",
  },
  {
    title: "Instructor",
    dataIndex: "instructor",
    key: "instructor",
  },
  {
    title: "Price",
    dataIndex: "cost",
    key: "cost",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Actions",
    key: "actions",
    align: "center",
    render: (_, record) => (
      <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
        <Button
          type="primary"
          onClick={(e) => {
            e.stopPropagation();
            handlePublishClass(record.id, fetchClasses, currentPage);
          }}
          style={{
            backgroundColor: "#3bdc35",
            fontSize: "12px",
            padding: "4px 8px",
            alignItem: "center"
          }}
        >
          Publish
        </Button>
        <Popconfirm
          title="Are you sure you want to reject this class?"
          onConfirm={(e) => {
            e?.stopPropagation();
            handleRejectClass(record.id, fetchClasses, currentPage);
          }}
          onCancel={(e) => e?.stopPropagation()}
          okText="Yes"
          cancelText="No"
        >
          <Button
            danger
            onClick={(e) => e.stopPropagation()}
            style={{
              fontSize: "12px",
              padding: "4px 8px",
            }}
          >
            Reject
          </Button>
        </Popconfirm>
      </div>
    ),
  }
];

const handlePublishClass = async (classId, fetchClasses, currentPage) => {
  try {
    const response = await publishClass(classId);
    if (response.code === 200) {
      message.success("Class published successfully!");
      fetchClasses(currentPage);
    } else {
      message.error("Failed to publish class: " + response.message);
    }
  } catch (error) {
    message.error("Error publishing class: " + error.message);
  }
};

const handleRejectClass = async (classId, fetchClasses, currentPage) => {
  try {
    const response = await rejectClass(classId);
    if (response.code === 200) {
      message.success("Class rejected successfully!");
      fetchClasses(currentPage);
    } else {
      message.error("Failed to reject class: " + response.message);
    }
  } catch (error) {
    message.error("Error rejecting class: " + error.message);
  }
};